import React from 'react';
import TechSpecs from '@hpstellar/pdp/TechSpecs';

import PDPSection from '../pdp-section';
import withPageComponents from '../../../page/components/with-page-components';


const pdpGallery = ({ techSpecs }) => {
  const { highlights = [], technical_specifications = [] } = techSpecs || {};

  return highlights.length > 0 || technical_specifications.length > 0 ? 
    <TechSpecs
      data={techSpecs}
      translations={{
        technical_details: 'Technical details',
        see_complete_specs: 'See complete specs',
        see_less_specs: 'See less specs'
      }}
    /> : null;
}

export default withPageComponents(pdpGallery, { components: ['techSpecs'] })
